import { call, select, takeLatest } from 'redux-saga/effects';
import * as notificationsApi from '@api/notifications';
import { actions } from './clinicalTrialNotificationHistory.slice';
import { FetchNotificationHistoryAction } from './clinicalTrialNotificationHistory.types';
import { Resp, dispatch } from '../helpers';
import { PaginationAndSortType } from '../paginationAndSort/paginationAndSort.types';
import { RootState } from '../store';
import { runToast } from '../tools';

export function* fetchNotificationHistoryWorker(
  action: FetchNotificationHistoryAction
) {
  const {
    clinicalTrialId,
    sort,
    notificationType,
    status,
    recipientName,
    recipientEmail,
    dispatchedFrom,
    dispatchedTo,
  } = action.payload;
  try {
    const pagSort = (yield select(
      (state: RootState) =>
        state.paginationAndSort?.lists?.notificationHistory || {
          currentPage: 1,
          currentPageSize: 10,
          sortBy: sort,
        }
    )) as PaginationAndSortType;

    const response: Resp<typeof notificationsApi.fetchNotificationHistory> =
      yield call(notificationsApi.fetchNotificationHistory, clinicalTrialId, {
        page: pagSort.currentPage,
        size: pagSort.currentPageSize,
        sort: sort ?? pagSort.sortBy,
        notificationType,
        status,
        recipientName,
        recipientEmail,
        dispatchedFrom,
        dispatchedTo,
      });

    yield dispatch(actions.fetchNotificationHistorySuccess(response));
  } catch (error) {
    yield dispatch(actions.fetchNotificationHistoryFailure(error));
    yield call(runToast, 'error', 'Error during fetching notification history');
  }
}

export function* clinicalTrialNotificationHistorySaga() {
  yield takeLatest(
    actions.fetchNotificationHistory.type,
    fetchNotificationHistoryWorker
  );
}
